import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    clear: 'Clear',
    save: 'Add to the invoice',
    searchPlaceholder: 'Search by name and description...',
    title: 'Add from your catalogue of products and services',
  },
  fr: {
    clear: 'Effacer',
    save: 'Ajouter à la facture',
    searchPlaceholder: 'Recherche par nom et description...',
    title: 'Ajouter un article depuis votre catalogue de produits et services',
  },
} as const);

export default locales;
